export interface ServiceAreaCity {
  name: string;
  slug: string;
  description: string;
  heroImage: string;
  localInfo: {
    about: string;
    landmarks: string[];
    neighborhoods?: string[];
  };
}

export const serviceAreaCities: ServiceAreaCity[] = [
  {
    name: "Maple Grove",
    slug: "maple-grove",
    description: "Our home base - professional lawn care and landscaping for Maple Grove residents.",
    heroImage: "/placeholder.svg",
    localInfo: {
      about: "Maple Grove is one of Minnesota's most desirable suburbs, known for its beautiful neighborhoods, excellent schools, and thriving retail areas. We're proud to call Maple Grove home and have been providing top-quality lawn care and landscaping services to our neighbors.",
      landmarks: ["The Shoppes at Arbor Lakes", "Elm Creek Park Reserve", "Central Park", "Maple Grove Community Center", "Fish Lake Regional Park"],
      neighborhoods: ["Arbor Lakes", "Weaver Lake", "Rush Creek", "Elm Creek", "Territorial"]
    }
  },
  {
    name: "Plymouth",
    slug: "plymouth",
    description: "Expert lawn maintenance and landscaping services for Plymouth homeowners.",
    heroImage: "/placeholder.svg",
    localInfo: {
      about: "Plymouth is a vibrant city known for its extensive trail system, beautiful lakes, and well-maintained neighborhoods. We've been keeping Plymouth lawns looking their best with professional lawn care, landscaping, and snow removal services.",
      landmarks: ["French Regional Park", "Plymouth Ice Center", "Hilde Performance Center", "Medicine Lake", "Parkers Lake"],
      neighborhoods: ["Wayzata West", "Medicine Lake", "Northwest Plymouth", "Fernbrook", "Sunset Hills"]
    }
  },
  {
    name: "Rogers",
    slug: "rogers",
    description: "Comprehensive lawn and landscape services for Rogers and surrounding areas.",
    heroImage: "/placeholder.svg",
    localInfo: {
      about: "Rogers has experienced tremendous growth while maintaining its charming small-town feel. We specialize in serving Rogers' larger properties and new developments with professional lawn care, landscaping, and snow removal services.",
      landmarks: ["Sonstegard Park", "Hassan Hills Park", "Rogers Activity Center", "SCHEELS Arena", "Industrial Boulevard corridor"],
      neighborhoods: ["Downtown Rogers", "Hassan", "Territorial", "Industrial area", "Brockton"]
    }
  },
  {
    name: "Medina",
    slug: "medina",
    description: "Trusted lawn and landscape professionals serving Medina homeowners.",
    heroImage: "/placeholder.svg",
    localInfo: {
      about: "Medina offers a rural lifestyle just minutes from the Twin Cities, featuring horse properties, hobby farms, and spacious estate lots. We specialize in caring for Medina's larger properties with professional lawn maintenance and landscaping services.",
      landmarks: ["Baker Park Reserve", "Wild Meadows Park", "Holy Name Lake", "Hamel", "Medina Entertainment Center"],
      neighborhoods: ["Downtown Hamel", "Holy Name Lake", "Independence", "Long Lake"]
    }
  },
  {
    name: "Corcoran",
    slug: "corcoran",
    description: "Full-service lawn care and landscaping for Corcoran properties.",
    heroImage: "/placeholder.svg",
    localInfo: {
      about: "Corcoran is a growing rural community that offers the perfect blend of country living and suburban convenience. We provide comprehensive lawn care and landscaping services for Corcoran's residential and rural properties.",
      landmarks: ["Corcoran Lions Park", "Lake Independence", "Spurzem Park", "Highway 101 corridor", "Lake Sarah"],
      neighborhoods: ["Corcoran", "Greenfield", "Lake Independence area", "Lake Sarah area"]
    }
  },
];
